// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"7e63d871e474c3ee","2931":"e3cb05d870a0a15b","4199":"fcbb0b5e169dcdb8","4316":"890f6f4190c9fdfb"}[chunkId] + ".js";
};